module.exports = __webpack_public_path__ + "media/images/ibu__logo__light-a0b0f460e5f5014c5ead58fc9af298c1.svg";